import { UserPermission } from "@ankaadia/ankaadia-shared";

export const OnlineApplicationPermissions = [UserPermission.ContentAdministrator];
